export enum MovementProviderEnum {
  Engineius,
  Movex,
  BCA,
  Manheim,
}
